import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconApples: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconApples"><Path d="M11.9989 20.7572C2.31195 24.87 -0.237657 1.73584 11.9991 6.87681C24.2385 1.73586 21.6885 24.87 11.9989 20.7572Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M8.93945 2.25C10.8505 3.25332 11.7435 4.71974 11.999 6.87682" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconApples;
